const initialState = {
    data: { reviewed: null },
};
import { getField, updateField } from 'vuex-map-fields';
import QuestionnaireProvider from "@/services/questionnaire.provider";
const questionnaireService = new QuestionnaireProvider();

export const questionnaire = {
    namespaced: true,
    state: initialState,
    actions: {
        async getQuestionnaire({ commit }, payload) {
            const data = await questionnaireService.getQuestionnaire(payload);
            commit('setQuestionnaire', data);
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        setQuestionnaire(state, data) { state.data = data },
    },
};